import { FC } from 'react'

import WatchCheckFileIcon from 'assets/icons/watch-check.svg'
import { WatchCheckSvgIcon } from 'components/Svg'

import { IconStyles } from '../types'
import { WatchCheckCustom } from './WatchCheck.styles'

interface IWatchCheckIcon extends IconStyles {
  onClick?: () => void
}

const WatchCheckIcon: FC<IWatchCheckIcon> = ({
  onClick,
  colorIcon,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  height,
  width,
  filter = false
}) => {
  return (
    <WatchCheckSvgIcon
      src={WatchCheckFileIcon}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      style={{ display: 'block', height: '35px', margin: '0', width: '35px' }}
      onClick={onClick}
      colorIcon={colorIcon}
      width={width}
      height={height}
      filter={filter}
    />
  )
}

export default WatchCheckIcon
